module.exports = __webpack_public_path__ + "img/1585943594.639ec896.jpg";